module.exports = __webpack_public_path__ + "img/ic_next_single_customer.0b84d00b.svg";